import { useMutation, useQuery } from '@apollo/client';
import { graphql } from 'gql.tada';

const AttendanceRollQuery = graphql.persisted(
  "AttendanceRollQuery",
  graphql(`
    query AttendanceRollQuery($scheduleBlockId: ID!, $date: ISO8601Date!) {
      scheduleBlock(id: $scheduleBlockId, date: $date) {
        id
        displayTitle
        activityKind
        timeLabel
        attendanceEnabled
        occursOn(date: $date)
        classroom { id name }
        studentPeopleOn(date: $date) { id firstName lastName }
        attendanceOn(date: $date) {
          id
          attendanceDate
          status
          notes
          person { id firstName lastName }
        }
      }
    }
  `),
);

const SaveAttendanceMutation = graphql.persisted(
  "SaveAttendance",
  graphql(`
    mutation SaveAttendance($input: SaveAttendanceInput!) {
      saveAttendance(input: $input) {
        records {
          id
          attendanceDate
          status
          notes
          person { id firstName lastName }
          scheduleBlock { id }
        }
        userErrors { message path code }
      }
    }
  `),
);

export { AttendanceRollQuery, SaveAttendanceMutation };

export function useAttendanceRollQuery(scheduleBlockId?: string, date?: string) {
  return useQuery(AttendanceRollQuery, {
    variables: { scheduleBlockId: scheduleBlockId!, date: date! },
    skip: !scheduleBlockId || !date,
    fetchPolicy: 'cache-and-network',
  });
}

export function useSaveAttendance() {
  return useMutation(SaveAttendanceMutation);
}
